import React from 'react';

const PopupsContext = React.createContext(null);

export default PopupsContext;
